<ul
  ngbNav
  #nav="ngbNav"
  class="nav nav-tabs flex-nowrap flex-shrink-0 overflow-x-auto overflow-y-hidden"
  (navChange)="onNavChange($event)"
>
  @for (tab of tabs(); track tab.title) {
    <li class="nav-item text-primary me-1 flex-shrink-0" [ngbNavItem]="$index">
      @if (tab.route) {
        <a
          ngbNavLink
          class="nav-link fw-bold px-4 py-3 text-nowrap"
          routerLinkActive="active"
          [routerLink]="tab.route"
          ><i class="fa-regular fa-xl" [class]="tab.icon"></i>
          @if (!layoutService.mobileView()) {
            <span class="ms-2">{{ tab.title | translate }}</span>
          }
        </a>
      } @else {
        <a ngbNavLink class="nav-link fw-bold px-4 py-3 text-nowrap"
          ><i class="fa-regular fa-xl" [class]="tab.icon"></i>
          @if (!layoutService.mobileView()) {
            <span class="ms-2">{{ tab.title | translate }}</span>
          }
        </a>
      }
    </li>
  }
</ul>

@if (isRouteBased()) {
  <router-outlet></router-outlet>
} @else {
  <ng-container
    [ngTemplateOutlet]="tabs()[activeTab()]?.template()"
  ></ng-container>
}
